import React from 'react';

import { FloatingLabelInput, IFloatingLabelInputProps } from 'components/floating-label-fields';

export const PhoneNumberField: React.FC<IFloatingLabelInputProps> = props => {
  return <FloatingLabelInput {...props} type="tel" />;
};

export default PhoneNumberField;
